import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { parse, stringify } from 'svgson';
// import svgrender.css
import './Canvas.css';

// import opencv findContours
// import { findContours } from 'opencv4nodejs';
// import { OpenCvProvider, useOpenCv } from 'opencv-react'

//create your forceUpdate hook
function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state


    return () => setValue(value => value + 1); // update the state to force render
}

const Canvas = (props) => {
    // call your hook here
    // const forceUpdate = useForceUpdate();
    const [renderState, setRenderState] = useState(0); 
    // const { loaded, cv } = useOpenCv()

    useEffect(() => {
        // if (props.svg != undefined) {
        //     const [x,y,w,h] =props.svg.attributes.viewBox.split(" ");
        //     console.log("w, h ", w,h);
        //     if (w>h) {
        //         svgAttributes = {
        //             width: String(props.zoomValue) + '%'
        //         }
        //     }
        //     else {
        //         svgAttributes = {
        //             height: String(props.zoomValue) + 'vh'
        //         }
        //     }
        // }

    });

    // write a function that converts an svg path to an image
    const svgToImage = (i) => {

        // take a screenshot of one path on the canvas
        const canvas = document.getElementById("canvas" + i);
        const ctx = canvas.getContext("2d");
        



        var tempSvg = props.svg;
        // props.svg.children[1]



        // props.setSvg(tempSvg);



        // var svgString = '<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">';

        // var svgPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

                // create an svgpathelement from the svgPath
                const svgPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
                svgPath.setAttribute("d", tempSvg.children[0].children[i].attributes.d);

        // get all points from the svgPath.d
        var points = svgPath.getAttribute("d").split(" ");
        // console.log("points ", points);




        // const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
        // const svgUrl = URL.createObjectURL(svgBlob);

        // use find contours from opencv to get the contours of the image 
        // var contours = cv.findContours(cv.imread(svgUrl), cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

        // const contours = findContours(svgUrl);
        // log all the contours
        // console.log(contours);

        // return svgUrl;
    }

    const changeColor = (i) => {
        var tempSvg = props.svg;
        console.log(props.svg.children[i].attributes['fill']);
        tempSvg.children[i].attributes['fill'] = props.color;
        props.setSvg(tempSvg);
        // it is not rerendering when I update the state so I have to force it.
        setRenderState(renderState + 1);
    }


    // write a function calles joinSVG that does the opposite of splitSVG
    const joinSVG = (split) => {
        // initialize an array of "" with length of join.children.length
        var joinedPaths = Array(split.children.length).fill("");
        for (var i = 0; i < split.children.length; i++) {
            for (var j = 0; j < split.children[i].children.length; j++) {
                joinedPaths[i] += split.children[i].children[j].attributes.d;
            }
        }

        var joined = props.svgJoined;
        // for each child in joined.children[i]
        for (var i = 0; i < joined.children.length; i++) {
            // update path with new attributes.d
            joined.children[i].attributes.d = joinedPaths[i];
        }

        console.log(joined);
        return joined
    }

    const deletePath = (i) => {
        var tempSvg = props.svg;
        // props.svg.children[1]

        console.log("test point",tempSvg.children[0]);

        tempSvg.children[0].children.splice(i, 1);//[i]
        props.setSvg(tempSvg);

        // it is not rerendering when I update the state so I have to force it.
        setRenderState(renderState + 1);
    }



    // const mergeColors = () => {
    //     var tempSvg = props.svg;
    //     var newChildren = [];
    //     var usedColors = [];

    //     for (let index = 0; index < props.svg.children.length; index++) {
    //         if (!usedColors.includes(props.svg.children[index].attributes['fill'])) {
    //             usedColors.push(props.svg.children[index].attributes['fill']);
    //         }
    //     }

    //     for (let colorIndex = 0; colorIndex < usedColors.length; colorIndex++) {
    //         var currentColor = usedColors[colorIndex];



    //         var childPath = '';
    //         for (let index = 0; index < props.svg.children.length; index++) {
                
    //             if (props.svg.children[index].attributes['fill'] == currentColor) {
    //                 childPath += props.svg.children[index].attributes['d'] + " "
    //             }
    //         }
    //         const child = Object.assign({}, props.svg.children[0]);
    //         const attributes = Object.assign({}, child.attributes);
    //         attributes.d = childPath;
    //         attributes.fill = currentColor;
    //         child.attributes = attributes;
    //         newChildren.push(child);
    //     }

    //     console.log(newChildren);
    //     tempSvg.children = newChildren;
    //     props.setSvg(tempSvg);
    //     forceUpdate();
    // }

    // const splitPaths = () => {
    //     var tempSvg = props.svg;
    //     var newChildren = [];
    //     for (let index = 0; index < props.svg.children.length; index++) {

    //         // if (props.svg.children[index].attributes['fill'] === "white") {
    //         const newString = props.svg.children[index].attributes['d'].replace(/M/g, "|M")

    //         const newArray = newString.split("|");


    //         for (var i = 0; i < newArray.length; i++) {
    //             var item = (' ' + newArray[i]).slice(1);
    //             if (item !== "") {
    //                 //console.log(item, i);
    //                 const child = Object.assign({}, props.svg.children[index]);
    //                 console.log("item", item);
    //                 const attributes = Object.assign({}, child.attributes);
    //                 attributes.d = item;
    //                 child.attributes = attributes;
    //                 console.log("attributes after", child.attributes.d);
    //                 console.log("child after", child);

    //                 newChildren.push(child);
    //             }
    //         }
    //     }
    //     console.log("newChildren: ", newChildren);
    //     tempSvg.children = newChildren;
    //     props.setSvg(tempSvg);
    //     forceUpdate();
    // }

    const clickHandler = (i) => {
        if (props.isCanvasDisabled) {
            return;
        }
        if (props.mouseMode === "fill") {
            changeColor(i);
        } else if (props.mouseMode === "delete") {
            deletePath(i);
        } else if (props.mouseMode === "testshape") {
            svgToImage(i);
        }

    }
    const mouseOverHandler = (e, i) => {
        if (props.isCanvasDisabled) {
            return;
        }
        if (e.buttons == 1 || e.buttons == 3) {
            if (props.mouseMode === "fill") {
                changeColor(i);
            } else if (props.mouseMode === "delete") {
                deletePath(i);
            }
        }


    }

    const svgAttributes = {
        height: String(props.zoomValue) + 'vh'
    };


    if (props.svg != undefined && props.svg.attributes != undefined && props.svgJoined != undefined && props.svgJoined.attributes != undefined) {
        return (
            <div key={props.svg}>
                {/* <svg viewBox={props.svg.attributes.viewBox} {...svgAttributes} xmlns="http://www.w3.org/2000/svg">
                   
                </svg> */}
                <svg viewBox={props.svgJoined.attributes.viewBox} {...svgAttributes} xmlns="http://www.w3.org/2000/svg">
                    <path d={props.svgJoined.children[0].attributes["d"]} stroke="none" fill={props.svgJoined.children[0].attributes["fill"]} fillRule={props.svgJoined.children[0].attributes["fill-rule"]}/>
                    {props.svg.children[0].children.map((object, i) => <path class="element" onMouseOver={(e) => mouseOverHandler(e, i)} onClick={() => clickHandler(i)} d={object.attributes["d"]} strokeWidth="1" stroke="none"  fill={object.attributes["fill"]} fill-opacity="0%" />)}
                  
                </svg>

            </div>
        );

    } else {
        return (
            <div key={props.svg}></div>
        );
    }

};

export default Canvas;